var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9918 3.20076L16.687 2.50551C18.7034 0.489129 21.9714 0.489129 23.9877 2.50551C26.0041 4.5219 26.0041 7.78989 23.9877 9.80622L23.2925 10.5015L15.9918 3.20076Z",
    fill: "#00347F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8323 11.9616L11.2636 22.5302L3.96294 15.2295L14.5316 4.66089L21.8323 11.9616Z",
    fill: "#00347F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.521304 24.929L2.50305 16.8635V16.8288C2.50305 16.7941 2.50305 16.7941 2.53772 16.7592L9.73413 23.9556C9.73413 23.9556 9.69945 23.9556 9.69945 23.9903H9.66477L1.59924 25.972C1.52964 25.972 1.46028 26.0067 1.39068 26.0067C1.14721 26.0067 0.938659 25.9024 0.765031 25.7632C0.556234 25.5549 0.451959 25.2421 0.521558 24.929L0.521304 24.929Z",
    fill: "#00347F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.c270af1e88ff07c61544b02ee13276d5.svg";
export { ForwardRef as ReactComponent };